import React from "react";
import SEO from "../../components/SEO";
import HeroSection from "../../pageComponents/homepageComponents/HeroSection";
import ClientMarquee from "../../pageComponents/homepageComponents/ClientMarquee";
import AboutSection from "../../pageComponents/homepageComponents/AboutSection";
import ProductSection from "../../pageComponents/homepageComponents/ProductSection";
import IndustriesSection from "../../pageComponents/homepageComponents/IndustriesSection";
import WhyUsSection from "../../pageComponents/homepageComponents/WhyUsSection";
import ProcessSection from "../../pageComponents/homepageComponents/ProcessSection";
import Testimonials from "../../pageComponents/homepageComponents/Testimonials";
import ContactUsSection from "../../pageComponents/homepageComponents/ContactUsSection";

const Home = () => {
  return (
    <>
      <SEO 
        title="Custom Label Printing Solutions" 
        description="Premium custom label printing company in Surat, India. Sahajink provides specialized labels for Pharmaceutical, Food, and Cosmetics industries globally."
        keywords="label printing solution, custom label printing surat, label printing company, label printing india, international label exporter, pharma labels surat"
      />
      <HeroSection />
      <ClientMarquee />
      <AboutSection />
      <ProductSection />
      <IndustriesSection />
      <WhyUsSection />
      <ProcessSection />
      <Testimonials />
      <ContactUsSection />
    </>
  );
};

export default Home;
